import * as React from "react";
import { useTranslation } from "react-i18next";
import { adjustFormat } from "util/DateTime";
import { isSearchingWarmTier } from "views/components/searchbar/queryvalidation/warmTierValidation";
const WarmTierErrorMessage = ({ warmTierIndices }) => {
  const { t } = useTranslation("search");
  if (!isSearchingWarmTier(warmTierIndices)) return null;
  const formatTimestamp = (timestamp) => `${adjustFormat(new Date(timestamp), "default")}`;
  const streamsWithTimestamp = () => {
    const streamTimestampsList = {};
    warmTierIndices.forEach((index) => {
      index.stream_names.forEach((streamName) => {
        if (!streamTimestampsList[streamName]) {
          streamTimestampsList[streamName] = [index.begin];
        } else {
          streamTimestampsList[streamName].push(index.begin);
        }
      });
    });
    return Object.entries(streamTimestampsList).map(([streamName, timestamps]) => {
      const sortedTimestamps = timestamps.sort((a, b) => a - b);
      const oldestTimestamp = sortedTimestamps[0];
      return { name: streamName, timestamp: oldestTimestamp };
    });
  };
  const streamsWithTimestampMap = streamsWithTimestamp();
  if ((streamsWithTimestampMap == null ? void 0 : streamsWithTimestampMap.length) <= 0) return null;
  return /* @__PURE__ */ React.createElement("span", null, t("query_validation.warm_tier_message"), /* @__PURE__ */ React.createElement("br", null), streamsWithTimestampMap.map((streamWithTimestamp) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("strong", null, streamWithTimestamp.name, ":"), " ", formatTimestamp(streamWithTimestamp.timestamp), /* @__PURE__ */ React.createElement("br", null))));
};
export default WarmTierErrorMessage;
